export enum WalletType {
  ETH = "ethereum",
  SOL = "solana",
}

export enum ApiSupportedChain {
  ETH = "eth",
  SOL = "sol",
}

export enum BotWalletSupportedChain {
  ETH = 1,
  SOL = 6517303,
}

export enum CodexChainId {
  ETH = 1,
  SOL = 1399811149,
}
